import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetLanguage"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/set-language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustbedrijfWidget"] */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/components/trustbedrijf-widget.tsx");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Volumes/capsule/MehmetikHome/PhpstormProjects/WinkelFactuur/factpromo/node_modules/next/dist/client/link.js");
